import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "steps" }
const _hoisted_2 = { class: "step-n mono" }
const _hoisted_3 = { class: "step-main" }
const _hoisted_4 = { class: "ops" }
const _hoisted_5 = { class: "step-explain" }

interface Step { ops: string[]; explain: string }

export default /*@__PURE__*/_defineComponent({
  __name: 'StepList',
  props: {
    steps: {}
  },
  setup(__props: any) {

// A numbered list of script steps: each step is an opcode row (framed) plus a
// plain-language explanation. Rendered from a template (not a render function)
// so the SFC's scoped styles actually apply to these elements.


function tokClass(t: string): string {
  if (t.startsWith('<') || t.startsWith('‹')) return 'tok-var'
  if (t.startsWith('OP_INSPECT') || t === 'OP_PUSHCURRENTINPUTINDEX') return 'tok-arkade'
  return 'tok-op'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (s, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "step"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(i + 1), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.ops, (t, j) => {
              return (_openBlock(), _createElementBlock("span", {
                key: j,
                class: _normalizeClass(["tok", tokClass(t)])
              }, _toDisplayString(t), 3))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(s.explain), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})